module.exports = __webpack_public_path__ + "static/media/office9.8c460b5f.jpg";